import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DISCORD_URL, EMAIL_SUPPORT } from '@app/config';
import { FaqAccordionComponent, SectionHeaderComponent } from '@app/widgets';
import { APP_STORE_PUBLISHING_FAQS } from '../../constants';

@Component({
  selector: 'app-app-store-publishing-faq-section',
  imports: [SectionHeaderComponent, FaqAccordionComponent],
  templateUrl: './app-store-publishing-faq-section.component.html',
  styleUrl: './app-store-publishing-faq-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppStorePublishingFaqSectionComponent {
  protected readonly discordUrl = DISCORD_URL;
  protected readonly emailSupport = EMAIL_SUPPORT;
  protected readonly items = APP_STORE_PUBLISHING_FAQS;
}
